/**
 * The Rail (unit convention §1). `railState` is the single discriminator prop
 * `Body` passes down; everything else each body reads for itself.
 *
 * Fix D gave it a model: which body the state implies, whether this is a
 * tournament game (the tabs and the 4th action tile), whether the engine is on
 * (the width mode and the engine host) and which viewport this is (the compact
 * action bar vs the phone's bottom toolbar).
 */
import React from 'react';

import {RailState} from '@/Store/liveGame/selectors';

import {bump} from '../../stage/renderCount';
import {useRailModel} from './model';
import RailView from './View';

export default React.memo(function Rail({railState}: {railState: RailState}) {
  bump('Rail');
  return <RailView railState={railState} {...useRailModel(railState)} />;
});
